// extracted by mini-css-extract-plugin
export default {"title":"HelpContent_title__F-Krs"};